import React, {useState} from "react";
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonItem,
  IonLabel,
  IonLoading,
  IonPage,
  IonRow,
  IonToast
} from "@ionic/react";
import Header from "../components/Header";
import {ROLE} from "../../enums/ROLE";
import {AuthContext} from "../../providers/authContext";
import {barChartOutline} from "ionicons/icons";
import {Calendar, CalendarValueType} from "primereact/calendar";
import yoneticiService from "../../services/YoneticiService";
import {formatDateToDDMMYYYY, logError} from "../../utils";
import {Chart, ChartProps} from "primereact/chart";
// import 'chart.js/auto';
import {TahsilatIzlemeGrafikVerisi} from "../entities/TahsilatIzlemeGrafikVerisi";

const YoneticiTahsilatGozlemGrafik: React.FC = () => {
  const { kurumBilgileri, logo } = React.useContext(AuthContext);
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [showToastMessage, setShowToastMessage] = useState<string>();
  const [tahsilatTarihi, setTahsilatTarihi] = useState<CalendarValueType>();
  const [grafikVerisi, setGrafikVerisi] = useState<TahsilatIzlemeGrafikVerisi>();
  const [chartData, setChartData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: 'Gelir Türü Toplamları',
        lineTension : 0.1,
        backgroundColor : "rgba(88,181,198,0.2)",
        borderColor : "rgba(88,181,198,1)",
        pointRadius : 5,
        pointBackgroundColor : "rgba(88,181,198,1)",
        pointBorderColor : "rgba(255,255,255,0.8)",
        pointHoverRadius : 5,
        pointHoverBackgroundColor : "rgba(88,181,198,1)",
        pointHitRadius : 50,
        pointBorderWidth : 2,
        data: []
      }
    ]
  });

  const options = {
    responsive: true,
    maintainAspectRatio: false,  // bu olmadan height'ı görmezden gelir
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 5000,
          maxTicksLimit: 20  // limiti artır ki stepSize'a saygı duysun
        }
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          // Varsayılan label yerine sadece değeri döndür
          label: function (context: any) {
            return context.formattedValue;
            // veya context.raw kullanabilirsiniz
          },
        },
      },
    },
    titleFontSize: 15,
    bodyFontSize: 15
  };

  const fetchData = (tar: Date) => {
    setShowLoading(true);
    yoneticiService
      .getTahsilatIzlemeGrafikVerisi(formatDateToDDMMYYYY(tar))
      .then((data: TahsilatIzlemeGrafikVerisi) => {
        setGrafikVerisi(data);
        setChartData({
          labels: data?.gelirTurListesi[0]?.split(',') ?? [],
          datasets: [
            {
              label: 'Gelir Türü Toplamları',
              lineTension : 0.1,
              backgroundColor : "rgba(88,181,198,0.2)",
              borderColor : "rgba(88,181,198,1)",
              pointRadius : 5,
              pointBackgroundColor : "rgba(88,181,198,1)",
              pointBorderColor : "rgba(255,255,255,0.8)",
              pointHoverRadius : 5,
              pointHoverBackgroundColor : "rgba(88,181,198,1)",
              pointHitRadius : 50,
              pointBorderWidth : 2,
              data: data?.tahsilatListesi[0]?.split(',') ?? []
            }
          ]
        })
      })
      .catch((error: any) => {
        logError(error);
        setShowToastMessage(
          error.response ? error.response.data.message : error
        );
      })
      .finally(() => setShowLoading(false));
  }

  const fetchToday = () => {
    const today = new Date();
    fetchData(today);
  }

  return (
    <IonPage>
      <Header
        title={kurumBilgileri?.kisaTanim}
        subtitle="Tahsilat Gözlem"
        logo={logo}
        roles={[ROLE.Yonetici]}
      />
      <IonContent>
        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={"Lütfen Bekleyin..."}
        />
        <IonToast
          isOpen={showToastMessage !== undefined}
          onDidDismiss={() => setShowToastMessage(undefined)}
          message={showToastMessage}
          duration={5000}
          position="top"
        />
        <IonCard>
          <IonCardHeader>
            <IonItem color="light">
              <IonIcon icon={barChartOutline} slot="start" />
              Tahsilat Toplamları
            </IonItem>
            <IonItem color="light">
              <IonGrid>
                <IonRow>
                  <IonCol size="5" sizeSm="2"><IonButton expand="block" onClick={() => {
                    setTahsilatTarihi(new Date());
                    fetchToday();
                  }}>Bugün</IonButton></IonCol>
                  <IonCol size="5" sizeSm="3"><IonButton expand="block" onClick={() => {
                    const yesterday = new Date();
                    yesterday.setDate(yesterday.getDate() - 1);
                    setTahsilatTarihi(yesterday);
                    fetchData(yesterday);
                  }} color="medium">Dün</IonButton></IonCol>
                </IonRow>
                <IonRow className="ion-align-items-center">
                  <IonCol size="5" sizeSm="2"><IonLabel>Tahsilat Tarihi	</IonLabel></IonCol>
                  <IonCol size="5" sizeSm="3">
                    <Calendar id="tahsilatTarihi" locale="tr"
                              dateFormat="dd.mm.yy"
                              value={tahsilatTarihi}
                              onChange={(e) => {
                                setTahsilatTarihi(e.value);
                                fetchData(e.value as Date);
                              }} showIcon />
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonItem>
          </IonCardHeader>
          <IonCardContent>
            <Chart type="bar" data={chartData} options={options}  style={{ height: '30rem' }} />
          </IonCardContent>
        </IonCard>
      </IonContent>
    </IonPage>
  )
};

export default YoneticiTahsilatGozlemGrafik;
